import React, { useEffect, useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState
} from 'recoil'
import { useIntl } from 'react-intl'
import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem,
  Title,
  TITLE_VARIANT_M,
  Grid,
  GridCell
} from 'mailup-web-components'

import { BASIC_VIEW, FULL_VIEW, QUICK_VIEW } from '../../const'
import {
  pageState,
  previewsListState,
  previewsPollingState
} from 'Pages/EmailMessagePreview/recoil/state/page'

import useMessageEditAction from 'Hooks/useMessageEditAction'
import useMessageSendAction from 'Hooks/useMessageSendAction'
import PreviewCard from 'Pages/EmailMessagePreview/components/QuickFullPreview/PreviewCard'
import {
  initPreviewsCallback,
  pollPreviewsCallback
} from 'Pages/EmailMessagePreview/recoil/callbacks/callbacks'
import ModalBeingSent from 'Pages/MessageCheckupSpamCheck/components/ModalBeingSent'

const QuickFullPreview = () => {
  const intl = useIntl()
  const history = useHistory()
  const { id } = useParams()
  const [{ view, isBee, messageType, clientsIdList }, setView] = useRecoilState(
    pageState
  )
  const { previewsIdList, loaded } = useRecoilValue(previewsListState)
  const resetList = useResetRecoilState(previewsListState)
  const { polling, pollingInterval, pollingIteration } = useRecoilValue(
    previewsPollingState
  )
  const initPreviews = useRecoilCallback(initPreviewsCallback, [])
  const pollPreviews = useRecoilCallback(pollPreviewsCallback, [])
  const timer = useRef(true)

  const handleSetView = pView => {
    setView(prev => ({
      ...prev,
      view: pView
    }))
    resetList()
    initPreviews(id, QUICK_VIEW)
  }

  const handleOverview = () => {
    history.push(`/messages/email/${id}/overview`)
  }

  const handleEdit = useMessageEditAction(id, isBee, messageType)
  const handleSend = useMessageSendAction(id)

  useEffect(() => {
    view === FULL_VIEW && initPreviews(id, view)
  }, [])

  useEffect(() => {
    if (polling && pollingIteration < 20) {
      timer.current = setTimeout(() => pollPreviews(id, view), pollingInterval)
      return () => clearTimeout(timer.current)
    }
  }, [polling, pollingInterval, pollingIteration])

  return (
    <>
      <ModalBeingSent />
      <Flex flexDirection='column'>
        <Flex
          flexDirection='row'
          margin='0 0 24px 0'
          justifyContent='space-between'
          columnGap='32px'
        >
          <Title variant={TITLE_VARIANT_M}>
            {view === FULL_VIEW &&
              intl.formatMessage({
                id: 'Load.EmailCheckUp.PreviewNewFullPreviewsBtn'
              })}
            {view === QUICK_VIEW &&
              intl.formatMessage({
                id: 'Load.EmailCheckUp.PreviewNewQuickPreviewsBtn'
              })}
          </Title>

          <Button
            kind={BUTTON_VARIANT_SECONDARY}
            onClick={() => handleSetView(BASIC_VIEW)}
          >
            {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
          </Button>
        </Flex>
        {!loaded && view === QUICK_VIEW && (
          <Grid cols={12}>
            {[...Array(2)].map(i => (
              <>
                <GridCell span={3} key={i}>
                  <PreviewCard previewId={i} />
                </GridCell>
              </>
            ))}
          </Grid>
        )}
        {!loaded && view === FULL_VIEW && (
          <Grid cols={12}>
            {clientsIdList.map(e => (
              <GridCell span={3} key={e}>
                <PreviewCard previewId={e} />
              </GridCell>
            ))}
          </Grid>
        )}
        {loaded && view === FULL_VIEW && (
          <Grid cols={12}>
            {clientsIdList.map((e, i) => (
              <GridCell span={3} key={i}>
                <PreviewCard previewId={e} />
              </GridCell>
            ))}
          </Grid>
        )}
        {loaded && view === QUICK_VIEW && (
          <Grid cols={12}>
            {previewsIdList.map((e, i) => (
              <GridCell span={3} key={i}>
                <PreviewCard previewId={e} />
              </GridCell>
            ))}
          </Grid>
        )}
        <Flex justifyContent='flex-end' margin='24px 0 0 0' columnGap='8px'>
          <FlexItem>
            <Button
              kind={BUTTON_VARIANT_SECONDARY}
              data-mu-test='cta-overview-footer'
              onClick={handleOverview}
            >
              {intl.formatMessage({ id: 'Load.MailupCommon.Overview' })}
            </Button>
          </FlexItem>
          <FlexItem>
            <Button
              kind={BUTTON_VARIANT_SECONDARY}
              data-mu-test='cta-edit-footer'
              onClick={handleEdit}
            >
              {intl.formatMessage({ id: 'Load.MailupCommon.Edit' })}
            </Button>
          </FlexItem>
          <FlexItem>
            <Button
              kind={BUTTON_VARIANT_PRIMARY}
              onClick={handleSend}
              data-mu-test='cta-send-footer'
            >
              {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
            </Button>
          </FlexItem>
        </Flex>
      </Flex>
    </>
  )
}

export default QuickFullPreview
